module.exports = __webpack_public_path__ + "img/mm.805490cd.jpg";